<template lang="pug">
#modal-atalho-territorio
    el-dialog(
        width='600px',
        :title='$t("mensagens.territorio.cadastroDeTerritorio")',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        span.espacamento
            | {{ $t('mensagens.pessoas.pessoaTerritorioVinculado') }}
        .botoes
            el-button(@click='fechar') {{ $t('mensagens.comuns.voltar') }}
            el-button(type='primary', @click='irParaTerritorio') {{ $t('mensagens.comuns.cadastrar') }}
</template>

<script>
export default {
    name: 'ModalAtalhoTerritorio',
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        isSucursal: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        irParaTerritorio() {
            if (this.isSucursal) {
                this.$router.push({ name: 'TerritorioSucursalesAcoes' });
            } else {
                this.$router.push({ name: 'CadastrarEditarTerritorio' });
            }
        },

        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>
<style lang="scss">
.botoes {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
}

.espacamento {
    word-break: break-word;
}
</style>
